import { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import AdminDashboard from './pages/admin/Dashboard'
import AdminUsers from './pages/admin/Users'
import AdminMedicalStaff from './pages/admin/MedicalStaff'
import AdminEvents from './pages/admin/Events'
import AdminGifts from './pages/admin/Gifts'
import AdminHospitals from './pages/admin/Hospitals'
import AdminExchangeRecords from './pages/admin/ExchangeRecords'
import DelegatedExchange from './pages/admin/DelegatedExchange'
import AdminStatistics from './pages/admin/Statistics'
import AdminRiskControl from './pages/admin/RiskControl'
import AdminAuditLog from './pages/admin/AuditLog'
import AdminPointRecords from './pages/admin/PointRecords'
import AdminVerify from './pages/admin/Verify'
import AdminScan from './pages/admin/Scan'
import AdminLogin from './pages/admin/Login'
import AdminSettings from './pages/admin/Settings'
import AdminPointEntry from './pages/admin/PointEntry'
import AdminContentDashboard from './pages/admin/ContentDashboard'
import AdminContentList from './pages/admin/ContentList'
import AdminContentEditor from './pages/admin/ContentEditor'
import AdminContentCategories from './pages/admin/ContentCategories'
import AdminContentStatistics from './pages/admin/ContentStatistics'
import AdminContentReviewQueue from './pages/admin/ContentReviewQueue'
import AdminContentTagsManage from './pages/admin/ContentTagsManage'
import AdminCommentsManage from './pages/admin/CommentsManage'
import AdminSensitiveWords from './pages/admin/SensitiveWords'
import MedicalDashboard from './pages/medical/Dashboard'
import MedicalEvents from './pages/medical/Events'
import MedicalVerify from './pages/medical/Verify'
import MedicalLogin from './pages/medical/Login'
import MedicalRegister from './pages/medical/Register'
import MedicalAccounts from './pages/medical/Accounts'
import MedicalUsers from './pages/medical/Users'
import MedicalPointEntry from './pages/medical/PointEntry'
import MedicalAuthorContentList from './pages/medical/AuthorContentList'
import MedicalAuthorContentEditor from './pages/medical/AuthorContentEditor'
import UserLogin from './pages/user/Login'
import UserRegister from './pages/user/Register'
import UserHome from './pages/user/Home'
import UserPoints from './pages/user/Points'
import UserExchange from './pages/user/Exchange'
import UserExchangeRecords from './pages/user/ExchangeRecords'
import UserProfile from './pages/user/Profile'
import UserScan from './pages/user/Scan'
import UserActivities from './pages/user/Activities'
import UserKnowledge from './pages/user/Knowledge'
import UserCategoryList from './pages/user/CategoryList'
import UserKnowledgeDetail from './pages/user/KnowledgeDetail'
import UserFavorites from './pages/user/Favorites'
import UserHistory from './pages/user/History'
import GiftDetail from './pages/user/GiftDetail'
import AccountSecurity from './pages/user/AccountSecurity'
import Notifications from './pages/user/Notifications'
import PersonalInfo from './pages/user/PersonalInfo'
import UserPointEntry from './pages/user/UserPointEntry'
import UserEvents from './pages/user/UserEvents'
import UserAccounts from './pages/user/UserAccounts'
import UserVerify from './pages/user/UserVerify'
import './index.css'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 用户端小程序 */}
        <Route path="/user" element={<Layout userType="user" />}>
          <Route index element={<UserHome />} />
          <Route path="login" element={<UserLogin />} />
          <Route path="register" element={<UserRegister />} />
          <Route path="home" element={<UserHome />} />
          <Route path="points" element={<UserPoints />} />
          <Route path="exchange" element={<UserExchange />} />
          <Route path="exchange-records" element={<UserExchangeRecords />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="scan" element={<UserScan />} />
          <Route path="activities" element={<UserActivities />} />
          <Route path="knowledge" element={<UserKnowledge />} />
          <Route path="knowledge/category/:categoryId" element={<UserCategoryList />} />
          <Route path="knowledge/:id" element={<UserKnowledgeDetail />} />
          <Route path="knowledge/favorites" element={<UserFavorites />} />
          <Route path="knowledge/history" element={<UserHistory />} />
          <Route path="gift/:id" element={<GiftDetail />} />
          <Route path="account-security" element={<AccountSecurity />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="personal-info" element={<PersonalInfo />} />
          <Route path="point-entry" element={<UserPointEntry />} />
          <Route path="events" element={<UserEvents />} />
          <Route path="accounts" element={<UserAccounts />} />
          <Route path="verify" element={<UserVerify />} />
        </Route>

        {/* 医护端 */}
        <Route path="/medical/login" element={<MedicalLogin />} />
        <Route path="/medical/register" element={<MedicalRegister />} />
        <Route path="/medical" element={<Layout userType="medical" />}>
          <Route index element={<MedicalDashboard />} />
          <Route path="dashboard" element={<MedicalDashboard />} />
          <Route path="events" element={<MedicalEvents />} />
          <Route path="verify" element={<MedicalVerify />} />
          <Route path="accounts" element={<MedicalAccounts />} />
          <Route path="users" element={<MedicalUsers />} />
          <Route path="point-entry" element={<MedicalPointEntry />} />
          <Route path="delegated-exchange" element={<DelegatedExchange />} />
          {/* 图文投稿：与管理端内容模块共用页面组件，接口走 /api/v1/author/content/*，
              医护只能看到自己的稿件（管理员走管理端 /admin/content） */}
          <Route path="author" element={<MedicalAuthorContentList />} />
          <Route path="author/list" element={<MedicalAuthorContentList />} />
          <Route path="author/new" element={<MedicalAuthorContentEditor />} />
          <Route path="author/:id" element={<MedicalAuthorContentEditor />} />
        </Route>

        {/* 管理端 */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Layout userType="admin" />}>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="medical-staff" element={<AdminMedicalStaff />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="gifts" element={<AdminGifts />} />
          <Route path="hospitals" element={<AdminHospitals />} />
          <Route path="exchange-records" element={<AdminExchangeRecords />} />
          <Route path="delegated-exchange" element={<DelegatedExchange />} />
          <Route path="point-records" element={<AdminPointRecords />} />
          <Route path="statistics" element={<AdminStatistics />} />
          <Route path="risk-control" element={<AdminRiskControl />} />
          <Route path="audit-log" element={<AdminAuditLog />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="verify" element={<AdminVerify />} />
          <Route path="point-entry" element={<AdminPointEntry />} />
          <Route path="scan" element={<AdminScan />} />
          <Route path="content" element={<AdminContentList />} />
          <Route path="content/overview" element={<AdminContentDashboard />} />
          <Route path="content/list" element={<AdminContentList />} />
          <Route path="content/new" element={<AdminContentEditor />} />
          <Route path="content/categories" element={<AdminContentCategories />} />
          <Route path="content/statistics" element={<AdminContentStatistics />} />
          <Route path='content/review-queue' element={<AdminContentReviewQueue />} />
          <Route path='content/tags' element={<AdminContentTagsManage />} />
          <Route path='content/comments' element={<AdminCommentsManage />} />
          <Route path='sensitive-words' element={<AdminSensitiveWords />} />
          <Route path="content/:id" element={<AdminContentEditor />} />
        </Route>

        {/* 默认重定向 */}
        <Route path="/" element={<Navigate to="/user" replace />} />
        <Route path="*" element={<Navigate to="/user" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
